import { React, useState, useEffect, useContext, useRef, useMemo } from 'react'
import { Link } from 'react-router-dom';
import Loading from "react-fullscreen-loading";
import DivLoader from "../../../component/utilities/Spinner";
import DataTable from "react-data-table-component";
import "../../../assets/css/dashboard.css";
import { FiCalendar, FiClock, FiCheckCircle, FiXCircle, FiMinusCircle, FiBarChart2, FiEye, FiEdit } from "react-icons/fi";
import axios from "axios";
import { toast } from "react-toastify";
import * as  CONST from "../../../component/config/Constant"
import Form from "../../../component/utilities/Forms";
import { AuthContext } from '../../../component/context/AuthContext';
/**For modal popup */
//import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2'
import DatePicker from 'react-datetime';
import moment from 'moment';
import JoditEditor from 'jodit-react';
import ViewLeaveDetails from './ViewLeaveDetails';
import LeaveImg from "../../../assets/img/icon/index.png";
import CancelLeaveImg from "../../../assets/img/icon/delete.svg";
import 'react-select2-wrapper/css/select2.css';
import MultiSelect from 'react-multiple-select-dropdown-lite'
import 'react-multiple-select-dropdown-lite/dist/index.css'
import Select from 'react-select';
import ExportCsv from '../../../component/export/ExportCsv';
// FiEye and FiXCircle already imported above

//import TimePicker from 'react-time-picker';

function List() {
    const [authUserData, setAuthUserData] = useContext(AuthContext);
    const [fullLoading, setFullLoading] = useState(false);
    const [validate, setValidate] = useState({});
    //const [processing, setProcessing] = useState(false);
    const [data, setData] = useState([]);
    const [headEmails, setHeadEmails] = useState([]);
    const [leaveTypeData, setLeaveTypeData] = useState([]);

    const [newHeads, setNewHeads] = useState([]);//newHeads = [];
    const [newHeadsCC, setNewHeadsCC] = useState([]);//newHeads = [];

    const [loading, setLoading] = useState(false);
    const [activePage, setActivePage] = useState(1);
    const [action, setAction] = useState('');
    const [leaveLisiting, setLeaveLisiting] = useState('');
    //const MySwal = withReactContent(Swal)
    const [listLimit, setListLimit] = useState(50);
    const [editLeaveId, setEditLeaveId] = useState(50);

    const [disabled, setDisabled] = useState('');
    const [approver, setApprover] = useState("");
    const [approverSource, setApproverSource] = useState("");
    const [deptHeadApprovers, setDeptHeadApprovers] = useState([]);
    const [deptEmployeeApprovers, setDeptEmployeeApprovers] = useState([]);

    /** form model popup */
    const [isLeaveModalShow, setLeaveModalShow] = useState(false);
    const [showLeaveModel, setLeaveShowModel] = useState({
        show: 'hide'
    });

    const editor = useRef(null);

    const config = useMemo(
        () => ({
            readonly: false,
            toolbarButtonSize: 'small',
            toolbarSticky: false,
            toolbarAdaptive: false,
            showCharsCounter: false,
            showWordsCounter: false,
            showXPathInStatusbar: false,
            buttons: "bold,italic,underline,|,ul,ol,|,undo,redo",
            height: 150,
        }),
        []
    );

    const [halfDaySession, setHalfDaySession] = useState('');

    //For Form
    const [to, setTo] = useState('');
    const [cc, setCc] = useState('');

    // const [toMail, setToMail] = useState([]);
    // const [ccMail, setCcMail] = useState([]);

    const [subject, setSubject] = useState('');
    const [leaveType, setLeaveType] = useState('');
    const [leaveTypeId, setLeaveTypeId] = useState('');
    const [reason, setReason] = useState('');
    const [leaveStartDate, setLeaveStartDate] = useState('');
    const [leaveEndDate, setLeaveEndDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [filterUsers, setfilterUsers] = useState([]);
    const headerData = [
        { label: "Name", key: "first_name" },
        { label: "Leave Type", key: "leave_type" },
        { label: "Leave Date", key: "leave_date" },
        { label: "Time", key: "time" },
        { label: "Leave Count", key: "leave_count" },
        { label: "Status", key: "status" }
    ];



    // Search Leave
    const [srchName, setSrchName] = useState('');
    const [srchStatus, setSrchStatus] = useState('');
    const [srchLeaveType, setSrchLeaveType] = useState('');
    const [srchLeaveDate, setSrchLeaveDate] = useState('');
    const [srchYear, setSrchYear] = useState(moment().format('YYYY'));
    const [srchMonth, setSrchMonth] = useState('');
    //const [srchLeaveStartDate, setSrchLeaveStartDate] = useState(moment().format('DD-MM-YYYY'));
    //const [srchLeaveEndDate, setSrchLeaveEndDate] = useState(moment().format('DD-MM-YYYY'));

    //const [srchDeptCode, setSrchDeptCode] = useState('');

    /* START DATATABLE */
    const [totalRecords, settotalRecords] = useState(0);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [maxPageLimit, setMaxPageLimit] = useState(10);
    const [minPageLimit, setMinPageLimit] = useState(0);
    const [searchParam, setSearchParam] = useState(
        {
            "srchName": srchName,
            "srchStatus": srchStatus,
            "srchLeaveDate": (srchLeaveDate != '') ? moment(srchLeaveDate).format('DD-MM-YYYY') : '',
            //"srchLeaveStartDate": (srchLeaveStartDate != '') ? moment(srchLeaveStartDate).format('DD-MM-YYYY'): '',
            //"srchLeaveEndDate": (srchLeaveEndDate != '') ? moment(srchLeaveEndDate).format('DD-MM-YYYY'): '',
            "srchLeaveType": srchLeaveType
        }
    );

    const [dataSort, setDataSort] = useState({
        order: 'desc',
        order_by: 'id'
    });
    const [viewData, setViewData] = useState([])
    const [showInput, setShowInput] = useState(false);
    //const pageNumberLimit = { perPage };


    let isToken = '';
    let userId = '';
    let deptId = '';
    let isAdmin = 0;
    let isHead = 0;
    if (authUserData) {
        if (authUserData[0]) {
            isToken = authUserData[0].token ? authUserData[0].token : "";
            userId = authUserData[0].user_id ? authUserData[0].user_id : 0;
            deptId = authUserData[0].department_id ? authUserData[0].department_id : 0;
            isAdmin = authUserData[0].is_admin ? authUserData[0].is_admin : 0;
            isHead = authUserData[0].is_head ? authUserData[0].is_head : 0;
        }
    }
    const canSelectDept = isAdmin == "1" || isHead == "1";
    //alert(JSON.stringify(authUserData));
    useEffect(() => {
        fetchLeavesData(searchParam, dataSort, activePage, perPage);
        fetchLeaveTypes();
        fetchHeadMails();
        fetchHeadCCMails();
    }, [searchParam, dataSort, activePage, listLimit]);

    /** For Modalpopup */
    const [show, setShow] = useState(false);
    //const [showCompOff, setShowCompOff] = useState(false);


    const closeLeave = async (type) => {
        setLeaveShowModel({
            show: 'hide'
        });
    }

    const handleLeaveShow = (row) => {
        setLoading(true);
        setLeaveModalShow(true);
        setLeaveShowModel({
            show: 'show'
        });
        setEditLeaveId(row.id);
        setViewData(row);
        setLoading(false);
    }

    const handleEditLeave = (row) => {
        setAction('Edit');
        setEditLeaveId(row.id);
        // leave_type is converted to string by backend: "Half Day"=0, "Full Day"=1, "Short Leave"=2
        var leaveTypeVal = row.leave_type;
        if (leaveTypeVal === 'Half Day') leaveTypeVal = '0';
        else if (leaveTypeVal === 'Full Day') leaveTypeVal = '1';
        else if (leaveTypeVal === 'Short Leave') leaveTypeVal = '2';
        else leaveTypeVal = String(leaveTypeVal);
        setLeaveType(leaveTypeVal);
        setLeaveTypeId(String(row.leave_type_id));
        setLeaveStartDate(moment(row.leave_from_date));
        setLeaveEndDate(row.leave_to_date ? moment(row.leave_to_date) : '');
        setSubject(row.subject || '');
        setReason(row.reason || '');
        // Set half day session from times
        if (leaveTypeVal === '0') {
            if (row.from_time === '09:00:00') setHalfDaySession('first');
            else if (row.from_time === '14:00:00') setHalfDaySession('second');
            else setHalfDaySession('');
        }
        // Pre-populate TO emails
        if (row.leaveToMailData && row.leaveToMailData.length > 0) {
            setTo(row.leaveToMailData.map(m => m.email).join(','));
        }
        // Pre-populate CC emails
        if (row.leaveCcMailData && row.leaveCcMailData.length > 0) {
            setCc(row.leaveCcMailData.map(m => m.email).join(','));
        }
        setShow(true);
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        const validate = await validateLeave();
        if (validate) {
            setLoading(true);
            setDisabled('disabled');
            let sendData = {
                id: userId,
                leave_id: editLeaveId,
                to: to,
                cc: cc,
                subject: subject,
                reason: reason,
                leave_type: leaveType,
                leave_type_id: leaveTypeId,
                leave_from_date: moment(leaveStartDate).format('YYYY-MM-DD'),
            }
            if (leaveType == "1") {
                sendData.leave_to_date = moment(leaveEndDate).format('YYYY-MM-DD');
            } else {
                if (halfDaySession === 'first') {
                    sendData.from_time = '09:00:00';
                    sendData.to_time = '13:00:00';
                } else {
                    sendData.from_time = '14:00:00';
                    sendData.to_time = '18:00:00';
                }
            }

            await axios({
                method: "post",
                url: CONST.UPDATE_LEAVE,
                data: sendData,
                headers: { 'Authorization': `Bearer ${isToken}` }
            })
            .then((response) => {
                if (response.data.status == 'error') {
                    toast.error(response.data.message || "Something went wrong.");
                } else {
                    toast.success(response.data.message);
                    handleClose();
                    fetchLeavesData(searchParam, dataSort, activePage, perPage);
                }
            })
            .catch((error) => {
                toast.error("Something went wrong. Please try again.");
            });
            setLoading(false);
            setDisabled('');
        }
    }

    const handleCancelLeave = (row) => {
        Swal.fire({
            // title: 'Are you sure?',
            html: "<strong>Do you want to cancel this leave?</strong>",
            content: "input",
            type: "input",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Cancel it!',
            animation: "slide-from-top",
            inputPlaceholder: "Add Your Comments",
            input: 'text',
            inputValue: "",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                if (row.id > 0) {

                    axios
                        .post(CONST.LEAVE_CANCEL,
                            {
                                leave_id: row.id,
                                id: userId,
                                status: '3',
                                comments: result.value,
                                cancel_by: userId
                            },
                            {
                                headers: {
                                    'Authorization': `Bearer ${isToken}`
                                }

                            })
                        .then((response) => {

                            if (response) {
                                if (response.data.status == 'error') {
                                    toast.error(response.data.message);
                                } else {
                                    toast.success(response.data.message);
                                    fetchLeavesData(searchParam, dataSort, activePage, perPage);
                                }
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            toast.error("Something went wrong. Please try again." + error);
                        });
                    setLoading(false);
                }
            }
        })
    }

    //fetch all Department details

    async function fetchLeaveTypes() {
        setLoading(true);
        await axios
            .post(CONST.LEAVE_TYPE_LIST, {
                search_input: '',
                page_number: ''
            }, {
                headers: {
                    'Authorization': `Bearer ${isToken}`
                }
            })

            .then((response) => {//alert('leave types: '+response);
                const status = response.data.status;
                if (status === 'success') {
                    setLeaveTypeData(response.data.data);
                }
            })
            .catch((error) => {
                alert(error);
            });
        setLoading(false);
    }


    async function fetchHeadMails() {
        let EmailArray = [];
        setLoading(true);
        await axios
            .get(CONST.GET_HEAD_EMAILS, {
                headers: {
                    'Authorization': `Bearer ${isToken}`
                }
            })

            .then((response) => {
                const status = response.data.status;
                if (status === 'success') {
                    //alert(JSON.stringify(response.data.data));
                    setHeadEmails(response.data.data);
                    let newData = response.data.data;
                    //alert('eduData >> '+ JSON.stringify(newData));
                    if (newData.length > 0) {
                        {
                            Object.keys(newData).map((key, index) => {
                                //newData[index].validate = {}
                                //newHeads.text = newData[index].name;
                                //newHeads.text = newData[index].name;
                                let optionsObj = {
                                    'text': newData[index].name,
                                    'value': newData[index].email,
                                }
                                EmailArray.push(optionsObj);

                            })
                        }


                        //alert('EmailArray'+JSON.stringify(newHeads));
                    }

                    let optionsVersion = newData.map((v, index) => (
                        { label: v.name, value: v.email }
                    ));


                    setNewHeads(optionsVersion);
                    //alert('EmailArray'+JSON.stringify(newHeads));
                }
            })
            .catch((error) => {
                alert(error);
            });
        setLoading(false);
    }

    async function fetchHeadCCMails() {
        let EmailArray = [];
        setLoading(true);
        await axios
            .post(CONST.GET_HEAD_CC_EMAILS, {
                id: userId,
            }, {
                headers: {
                    'Authorization': `Bearer ${isToken}`
                }
            })

            .then((response) => {
                const status = response.data.status;
                if (status === 'success') {
                    //alert(JSON.stringify(response.data.data));
                    setNewHeadsCC(response.data.data);
                    let newData = response.data.data;
                    //alert('eduData >> '+ JSON.stringify(newData));
                    if (newData.length > 0) {
                        {
                            Object.keys(newData).map((key, index) => {
                                //newData[index].validate = {}
                                //newHeads.text = newData[index].name;
                                //newHeads.text = newData[index].name;
                                let optionsObj = {
                                    'text': newData[index].name,
                                    'value': newData[index].email,
                                }
                                EmailArray.push(optionsObj);

                            })
                        }


                        //alert('EmailArray'+JSON.stringify(newHeads));
                    }

                    let optionsVersion = newData.map((v, index) => (
                        { label: v.name, value: v.email }
                    ));


                    setNewHeadsCC(optionsVersion);
                    //alert('EmailArray'+JSON.stringify(newHeads));
                }
            })
            .catch((error) => {
                alert(error);
            });
        setLoading(false);
    }

    async function fetchMissingLeaveApprovers() {
        try {
            const headRes = await axios.get(CONST.GET_HEAD_USER, {
                headers: { 'Authorization': `Bearer ${isToken}` }
            });
            if (headRes.data.status === "success") {
                setDeptHeadApprovers(headRes.data.data || []);
            }
            const empRes = await axios.post(CONST.GET_HEAD_CC_EMAILS, {
                id: userId, department_id: String(deptId)
            }, {
                headers: { 'Authorization': `Bearer ${isToken}` }
            });
            if (empRes.data.status === "success") {
                setDeptEmployeeApprovers(empRes.data.data || []);
            }
        } catch (error) {
            console.log("fetchMissingLeaveApprovers error:", error);
        }
    }

    const handleOnchangeTo = val => {
        if (val.indexOf('other') !== -1) {
            setShowInput(true);
        }
        else {
            setShowInput(false);
        }
        setTo(val)
    }

    const handleOnchangeCC = val => {
        if (val.indexOf('other') !== -1) {
            setShowInput(true);
        }
        else {
            setShowInput(false);
        }
        setCc(val)
    }

    const validateLeave = async () => {
        let isValid = true;

        let validator = Form.validator({
            to: {
                value: to,
                isRequired: true,
                isEmail: false,
                label: "To",
            },
            /*cc: {
                value: cc,
                isRequired: false,
                isEmail: true,
                label: "CC",
            },*/
            subject: {
                value: subject,
                isRequired: true,
                isEmail: false,
                label: "Subject",
            },
            reason: {
                value: reason,
                isRequired: true,
                isEmail: false,
                label: "Reason",
            },
            leaveType: {
                value: leaveType,
                isRequired: true,
                isEmail: false,
                label: "Leave Type",
            },
            leaveTypeId: {
                value: leaveTypeId,
                isRequired: true,
                isEmail: false,
                label: "Leave Type",
            },
            leaveStartDate: {
                value: leaveStartDate,
                isRequired: true,
                isEmail: false,
                label: "Start Date",
            },

            /*leaveEndDate: {
                value: leaveEndDate,
                isRequired: true,
                isEmail: false,
                label: "leaveEndDate",
            },*/

        });
        console.log('validator:' + JSON.stringify(validator));
        if (validator !== null) {
            setValidate({
                validate: validator.errors,
            });
            isValid = false;
            const firstError = Object.values(validator.errors)[0];
            toast.error(firstError ? firstError[0] : "Please fill all required fields.");
        } else {
            setValidate({
                validate: "",
            });
            isValid = true;
        }
        return isValid;
    };

    const validateMissingLeave = async () => {
        let isValid = true;

        let validator = Form.validator({
            approver: {
                value: approver,
                isRequired: true,
                isEmail: false,
                label: "Approver",
            },
            subject: {
                value: subject,
                isRequired: true,
                isEmail: false,
                label: "Subject",
            },
            reason: {
                value: reason,
                isRequired: true,
                isEmail: false,
                label: "Reason",
            },
            leaveType: {
                value: leaveType,
                isRequired: true,
                isEmail: false,
                label: "Leave Type",
            },
            leaveTypeId: {
                value: leaveTypeId,
                isRequired: true,
                isEmail: false,
                label: "Leave Type",
            },
            leaveStartDate: {
                value: leaveStartDate,
                isRequired: true,
                isEmail: false,
                label: "Start Date",
            },
        });
        console.log('Missing Leave validator result:', JSON.stringify(validator));
        if (validator !== null) {
            setValidate({
                validate: validator.errors,
            });
            isValid = false;
            const firstError = Object.values(validator.errors)[0];
            toast.error(firstError ? firstError[0] : "Please fill all required fields.");
        } else {
            console.log('Missing Leave validation passed');
            setValidate({
                validate: "",
            });
            isValid = true;
        }
        return isValid;
    };

    // const handleSetMails = (e, field) => {
    //     //alert('23');
    //     var options = e.target.options;

    //     let value = Array.from(e.target.selectedOptions, option => option.value);
    //     //alert(options.length+'||'+value)

    //     // if(field === 'to'){
    //     //     setTo(value);
    //     // }else{
    //     //     setCc(value);
    //     // }
    //     //setTo({multiValue: [...e.target.selectedOptions].map(o => o.value)}); 
    //     console.log("todays to>> " + to);
    // }

    const handleSubmit = async (e) => {

        // alert('toooo:'+to); alert('ccccc:'+cc);
        e.preventDefault();
        const validate = await validateLeave();
        if (validate) {
            setLoading(true);
            setDisabled('disabled');
            let sendData = {
                id: userId,
                to: to,
                cc: cc,
                subject: subject,
                reason: reason,
                leave_type: leaveType,
                leave_type_id: leaveTypeId,
                leave_from_date: moment(leaveStartDate).format('YYYY-MM-DD'),
                approve_leave_url: CONST.APP_LINK + 'admin/employee/leaves/all',
                //leave_to_date: moment(leaveEndDate).format('YYYY-MM-DD')
            }
            if (leaveType == "1") {
                sendData.leave_to_date = moment(leaveEndDate).format('YYYY-MM-DD');
            } else {
                // Half day: First Half = 09:00-13:00, Second Half = 14:00-18:00
                if (halfDaySession === 'first') {
                    sendData.from_time = '09:00:00';
                    sendData.to_time = '13:00:00';
                } else {
                    sendData.from_time = '14:00:00';
                    sendData.to_time = '18:00:00';
                }
            }
            //alert(JSON.stringify(sendData));

            await axios({
                method: "post",
                url: CONST.APPLY_LEAVE,
                data: sendData,
                headers: {
                    'Authorization': `Bearer ${isToken}`
                }

            })
                .then((response) => {
                    console.log('apply leave response: ' + JSON.stringify(response));
                    //alert(response.data.status);
                    if (response) {

                        if (response.data.status == 'error') {

                            toast.error("Something went wrong. Please try again.");
                        } else {
                            toast.success(response.data.message);
                            handleClose();
                            fetchLeavesData(searchParam, dataSort, activePage, perPage)
                            setLoading(false);
                            setDisabled('');
                        }
                    }
                })
                .catch((error) => {
                    setLoading(false);
                    setDisabled('');
                    console.log('leave Error: ' + error);
                    toast.error("Something went wrong. Please try again." + error);
                });


        } else {
            //console.log('err-'+JSON.stringify(validator));
            //toast.error("Error: "+ validator.errors);
        }

    }

    const handleMissingSubmit = async (e) => {
        e.preventDefault();
        if (!approver || !leaveType || !leaveTypeId || !leaveStartDate || !subject) {
            toast.error("Please fill all required fields.");
            return;
        }
        setLoading(true);
        setDisabled('disabled');
        try {
            let sendData = {
                id: userId,
                subject: subject,
                reason: reason,
                leave_type: leaveType,
                leave_type_id: leaveTypeId,
                leave_from_date: moment(leaveStartDate).format('YYYY-MM-DD'),
                approved_by: approver,
            };
            if (leaveType == "1") {
                sendData.leave_to_date = moment(leaveEndDate).format('YYYY-MM-DD');
            }
            sendData.from_time = startTime ? moment(startTime).format('HH:mm:ss') : '00:00:00';
            sendData.to_time = endTime ? moment(endTime).format('HH:mm:ss') : '00:00:00';

            const response = await axios.post(CONST.ADD_MISSING_LEAVE, sendData, {
                headers: { 'Authorization': `Bearer ${isToken}` }
            });
            if (response.data.status == 'error') {
                toast.error(response.data.message || "Something went wrong.");
            } else {
                toast.success(response.data.message);
                handleClose();
                fetchLeavesData(searchParam, dataSort, activePage, perPage);
            }
        } catch (error) {
            toast.error("Something went wrong. Please try again.");
        }
        setLoading(false);
        setDisabled('');
    }



    const geLeaveType = (leave_type) => {
        //console.log('LLLL'+leave_type)
        /* if(leave_type == '0'){
             return 'Full Day';
         }else if(leave_type == '1'){
             return 'Half Day';
         }else{
             return 'Short Leave';
         }*/
        return (leave_type);
    }

    const formatTime = (date) => {
        return date.slice(0, -3);
    }

    const leaveTypeArr = {
        '0': 'Full Day',
        '1': 'Half Day',
        '2': 'Short Leave',
    }

    const CustomLeaveType = ({ row }) => (

        <div className="d-flex py-1 align-items-center">

            <div className="flex-fill pl-2">
                <div className="font-weight-medium"> {row.leave_type}</div>
                <div className="text-muted">
                    <span className="text-muted" >
                        <small>
                            {(row.e_leave_type) ? row.e_leave_type.name : ''} Leave
                        </small>
                    </span>
                </div>


            </div>
        </div>
    );

    const CustomLeaveDate = ({ row }) => (

        <div className="d-flex py-1 align-items-center">

            <div className="flex-fill pl-2">
                <div className="font-weight-medium"> {moment(row.leave_from_date).format('DD-MM-YYYY') + ((row.leave_type == 'Full Day') ? ' to ' + moment(row.leave_to_date).format('DD-MM-YYYY') : '')}</div>
                <div className="text-muted">
                    <span className="text-muted" >
                        <small>
                            {((row.leave_type == 'Full Day') ? row.no_of_days + ' Day(s)' : '')}

                        </small>
                    </span>
                </div>


            </div>
        </div>
    );

    const getBalanceBadgeClass = (total, balance) => {
        const currentMonth = new Date().getMonth() + 1;
        const monthsRemaining = 12 - currentMonth;
        const leavesPerMonth = total / 12;
        const expectedBalance = leavesPerMonth * monthsRemaining;

        if (balance <= expectedBalance * 0.5) return "bg-danger";
        if (balance <= expectedBalance * 0.85) return "bg-warning text-dark";
        return "bg-success";
    };

    const CustomLeaveCount = ({ row }) => (
        <div className="d-flex py-1 align-items-center">
            <div className="flex-fill pl-2">
                <div className="fw-bold small">Total : {row.totalLeaveCount}</div>
                <div className="fw-bold small">Used : {row.consumedLeaveCount}</div>
                <span className={`badge rounded-pill ${getBalanceBadgeClass(row.totalLeaveCount, row.balanceLeaveCount)}`}>
                    Balanced : {row.balanceLeaveCount}
                </span>
            </div>
        </div>
    );
    const LeaveStatus = ({ row }) => {
        const status = row.status;
        const map = {
            0: { label: "Pending", bg: "#fffbeb", color: "#d97706" },
            1: { label: "Approved", bg: "#ecfdf5", color: "#059669" },
            2: { label: "Rejected", bg: "#fef2f2", color: "#dc2626" },
            3: { label: "Cancelled", bg: "#f1f5f9", color: "#94a3b8" },
        };
        const s = map[status] || map[0];
        return status != null ? (
            <span style={{ background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 20, fontSize: '0.7rem', fontWeight: 600 }}>
                {s.label}
            </span>
        ) : null;
    };

    const LeaveStatusChangedBy = ({ row }) => (
        <>

            {(() => {


                if (row.status == 1) {
                    return (
                        <div>

                            <span className=''>Approved by {(row.approvedByUser) ? row.approvedByUser.first_name + ' ' + row.approvedByUser.last_name : '-'}</span>
                        </div>
                    )
                } else if (row.status == 2) {
                    return (
                        <div>

                            <span className=''>Rejected by {(row.approvedByUser) ? row.approvedByUser.first_name + ' ' + row.approvedByUser.last_name : '-'}</span>
                        </div>
                    )
                } else {
                    return (
                        <span className=''>-</span>
                    )
                }


            })()}
        </>
    )

    const columns = [
        {
            name: 'Leave Type',
            cell: (row) => (
                <div>
                    <div style={{ fontWeight: 600, fontSize: '0.85rem', color: '#0a1628' }}>{row.leave_type}</div>
                    <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{row.e_leave_type ? row.e_leave_type.name : ''}</div>
                </div>
            ),
            width: "12%",
            wrap: true,
        },
        {
            name: 'Date',
            cell: (row) => (
                <div>
                    <div style={{ fontWeight: 500, fontSize: '0.85rem', color: '#0a1628' }}>
                        {moment(row.leave_from_date).format('DD MMM YYYY')}
                        {row.leave_type === 'Full Day' && row.leave_to_date ? ' - ' + moment(row.leave_to_date).format('DD MMM YYYY') : ''}
                    </div>
                    {row.leave_type === 'Full Day' && row.no_of_days ? (
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{row.no_of_days} Day(s)</div>
                    ) : row.from_time ? (
                        <div style={{ fontSize: '0.75rem', color: '#64748b' }}>{formatTime(row.from_time)} - {formatTime(row.to_time)}</div>
                    ) : null}
                </div>
            ),
            width: "18%",
            wrap: true,
            sortable: true,
            sortField: "leave_from_date",
        },
        {
            name: 'Subject',
            selector: (row) => row.subject,
            width: "18%",
            wrap: true,
        },
        {
            name: 'Leave Balance',
            cell: (row) => (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span style={{ background: '#f0f5ff', color: '#1167e8', padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{row.totalLeaveCount} Total</span>
                    <span style={{ background: '#fef2f2', color: '#dc2626', padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{row.consumedLeaveCount} Used</span>
                    <span style={{ background: '#ecfdf5', color: '#059669', padding: '2px 8px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>{row.balanceLeaveCount} Bal</span>
                </div>
            ),
            width: "20%",
            wrap: true,
        },
        {
            name: 'Status',
            cell: (row) => <LeaveStatus row={row} />,
            width: "8%",
        },
        {
            name: 'Approver',
            cell: (row) => <LeaveStatusChangedBy row={row} />,
            width: "14%",
            wrap: true,
        },
        {
            name: "Action",
            cell: (row) => <Leave row={row} />,
            width: "10%",
            wrap: true,
        },
    ]

    const Leave = ({ row }) => (
        <div style={{ display: 'flex', gap: '8px' }}>
            <Link to={'#'} data-id={row.id} onClick={() => handleLeaveShow(row)} title="View Leave Details" className="action-icon-btn">
                <FiEye size={18} />
            </Link>

            {row.status == 0 && (
                <Link to={'#'} data-id={row.id} onClick={() => handleEditLeave(row)} title="Edit Leave" className="action-icon-btn">
                    <FiEdit size={18} />
                </Link>
            )}

            {row.status == 0 && (
                <Link to={'#'} data-id={row.id} onClick={() => handleCancelLeave(row)} title="Cancel Leave" className="action-icon-btn">
                    <FiXCircle size={18} />
                </Link>
            )}
        </div>
    );

    const handleChangeStatus = (index, val, leaveID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "Do you want to change the status?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, change it!'
        }).then((result) => {
            if (result.isConfirmed) {
                setLoading(true);
                axios.post(CONST.UPDATE_LEAVE_STATUS,
                    {
                        'id': userId,
                        'leave_id': leaveID,
                        'status': (val == '0') ? '1' : '0',
                    },
                    {
                        headers: {
                            'Authorization': `Bearer ${isToken}`
                        }
                    }
                )
                    .then((response) => {
                        console.log(response);
                        const status = response.data.status;
                        if (status == 'success') {
                            toast.success(response.data.message);
                        } else {
                            toast.error(response.data.message);
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        toast.error("There was an error.");
                    });
                setLoading(false);

                const newData = [...data];
                newData[index].status = (val == 0) ? 1 : 0;
                setData(newData);
            }
        })

    }

    {/*const Action = ({ row }) => (
        <>
            <Link to={'#'} data-id={row.id} onClick={() => handleShow('Edit', row.id)}>
                <img src={editImg} alt='editUser' width={32} className='cursor' />
            </Link>
            <Link onClick=''>
                <img src={deleteImg} alt='deleteImg' width={32} className='cursor' />
            </Link>


        </>
    )*/ }



    const searchMonthChange = val => {

        if (val != '') {
            setSrchMonth(moment(val).format('MM'))
        } else {
            setSrchMonth('')
        }
    }

    const searchYearChange = val => {
        if (val != '') {
            setSrchYear(moment(val).format('YYYY'))
        } else {
            setSrchYear('')
        }

    }

    async function searchLeaves() {
        setSearchParam({
            "srchName": srchName,
            "srchStatus": srchStatus,
            "srchLeaveDate": (srchLeaveDate != '') ? moment(srchLeaveDate).format('DD-MM-YYYY') : '',
            //"srchLeaveStartDate": (srchLeaveStartDate != '') ?moment(srchLeaveStartDate).format('DD-MM-YYYY'): '',
            //"srchLeaveEndDate": (srchLeaveEndDate != '') ?moment(srchLeaveEndDate).format('DD-MM-YYYY'): '',
            "srchLeaveType": srchLeaveType
        })
        setDataSort({
            order: "desc",
            order_by: "id"
        });
        setActivePage("1");

    }

    function clearSearch() {
        setSearchParam({
            "srchName": '',
            "srchStatus": '',
            "srchLeaveDate": '',
            //"srchLeaveStartDate":'',
            //"srchLeaveEndDate":'',
            "srchLeaveType": '',
        })
        setDataSort({
            order: "desc",
            order_by: "id"
        });
        setActivePage("1");
        setSrchMonth('');
        setSrchYear(moment().format('YYYY'));

    }


    // async function getDeptByID(dept_id) {

    //     await axios
    //         .get(CONST.GET_DEPARTMENT_BY_ID + '/' + dept_id,
    //             {
    //             headers: {
    //                 'Authorization': `Bearer ${isToken}`,
    //                 'Content-Type': 'application/x-www-form-urlencoded',
    //             },
    //             params: { 
    //                 //'dept_id': dept_id 
    //             },

    //         },

    //         )

    //         .then((response) => {
    //             const status = response.data.status;

    //             console.log(response.data.data[0]);
    //             if (status === 'success') {
    //                 let deptData = response.data.data[0] ? response.data.data[0] : [];
    //                 setDepartmentName( deptData['name'] ? deptData['name'] : '' );
    //                 setStatus( deptData['status'] ? deptData['status'] : '' );
    //                 setEmail( deptData['email'] ? deptData['email'] : '' );
    //             }
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }

    async function fetchLeavesData(paramSearch, paramSort, paramPage, paramLimit) {
        setLoading(true);

        let param = {
            'id': userId,
            'limit': paramLimit,
            'search_input': paramSearch,
            'page_number': paramPage,
            'sort': paramSort
        }
        console.log('leave param: ' + JSON.stringify(param));
        //alert('srchLeaveDate'+srchLeaveDate);
        await axios
            .post(CONST.GET_USER_LEAVES,
                {
                    // "department_id":deptId,
                    "id": userId,
                    "limit": paramLimit,
                    "year": srchYear,
                    "month": srchMonth,
                    "page_number": paramPage,
                    "search_input": paramSearch,
                    "sort": paramSort
                },
                {
                    headers: {
                        'Authorization': `Bearer ${isToken}`
                    },

                })

            .then((response) => {
                console.log('Leaves Res- ' + JSON.stringify(response));
                const status = response.data.status;

                if (status === 'success') {
                    setLeaveLisiting(response.data.data);
                    setTotalRows(response.data.count);

                    settotalRecords(response.data.count);
                    setData(response.data.data);
                    const userListJson = response.data.data;
                    const transformedData = userListJson.map(data => ({
                        ...data,
                        first_name: (data.user) ? `${data.user.first_name} ${data.user.last_name}` : '-',
                        leave_type: `${data.leave_type} ${(data.e_leave_type) ? data.e_leave_type.name : ''}`,
                        leave_date: `${moment(data.leave_from_date).format('DD-MM-YYYY') + ((data.leave_type == 'Full Day' && data.leave_to_date) ? ' to ' + moment(data.leave_to_date).format('DD-MM-YYYY') : '')} ${((data.leave_type == 'Full Day') ? data.no_of_days + ' Day(s)' : '')}`,
                        time: `${(data.leave_type == 'Full Day') ? ' - ' : formatTime(data.from_time) + ' - ' + formatTime(data.to_time)}`,
                        leave_count: `${'Total:' + '' + data.totalLeaveCount} ${'Used:' + '' + data.consumedLeaveCount} ${'Balanced:' + '' + data.balanceLeaveCount}`,
                        status: `${(data.status == 0) ? 'pending' : (data.status == 1) ? 'Approved' : (data.status == 2) ? 'Rejected' : 'Cancelled'}`,
                    }));
                    // console.log('myfinaldata', transformedData)
                    setfilterUsers(transformedData)
                } else {
                    setLeaveLisiting('');
                    setTotalRows(0);
                    settotalRecords(0);
                    setData('');
                    toast.error(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        setLoading(false);
    }


    const handlePerRowsChange = async (perPage, page) => {
        console.log('handlePerRowsChange');
        setLoading(true);
        const response = await axios.get(
            `https://reqres.in/api/users?page=${page}&per_page=${perPage}&delay=1`
        );
        setData(response.data);
        setPerPage(perPage);
        setLoading(false);
    };

    function toPages(pages) {
        const results = [];
        for (let i = 1; i <= pages; i++) {
            results.push(i);
        }
        return results;
    }

    function getNumberOfPages(rowCount, rowsPerPage) {
        return Math.ceil(rowCount / rowsPerPage);
    }

    const handleSort = async (column, sortDirection) => {
        setActivePage(1);
        setSearchParam({
            "srchName": srchName,
            "srchStatus": srchStatus,
            "srchLeaveDate": (srchLeaveDate != '') ? moment(srchLeaveDate).format('DD-MM-YYYY') : '',
            "srchLeaveType": srchLeaveType
        })

        setDataSort({
            order: sortDirection,
            order_by: column.sortField
        })
    };



    /*  PAGINATION FUNCTIONS  */
    const handlePageChange = async (page) => {
        console.log(page);
        setActivePage(page)
    };

    const BootyPagination = ({
        rowsPerPage,
        rowCount,
        onChangePage,
        onChangeRowsPerPage, // available but not used here
        currentPage,
    }) => {

        const handleBackButtonClick = async () => {
            if ((currentPage - 1) % perPage === 0) {
                setMaxPageLimit(maxPageLimit - perPage);
                setMinPageLimit(minPageLimit - perPage);
            }
            onChangePage(currentPage - 1);
        };

        const handleNextButtonClick = async () => {
            if (currentPage + 1 > maxPageLimit) {
                setMaxPageLimit(maxPageLimit + perPage);
                setMinPageLimit(minPageLimit + perPage);
            }

            onChangePage(currentPage + 1);
        };

        const handlePageNumber = (e) => {
            onChangePage(Number(e.target.value));
        };

        let paginationText = "Page:  " + currentPage + ", Showing ";

        paginationText =
            paginationText +
            ((currentPage - 1) * perPage + 1) +
            " to " +
            perPage * currentPage;
        paginationText = paginationText + " of " + rowCount + " entries;";
        const pages = getNumberOfPages(rowCount, rowsPerPage);
        const pageItems = toPages(pages);
        const nextDisabled = currentPage === pageItems.length;
        const previosDisabled = currentPage === 1;

        const pageNumbers = pageItems.map((page) => {
            if (page <= maxPageLimit && page > minPageLimit) {
                return (
                    <li
                        key={page}
                        id={page}
                        className={`page-item ${currentPage === page ? "active" : ""}`}
                    >
                        <button
                            className={`page-link ${currentPage === page ? "active" : ""}`}
                            onClick={handlePageNumber}
                            value={page}
                        >
                            {page}
                        </button>
                    </li>
                );
            } else {
                return null;
            }
        });
        let pageIncrementEllipses = null;
        if (pageItems.length > maxPageLimit) {
            pageIncrementEllipses = (
                <li className="page-item" onClick={handleNextButtonClick}>
                    &hellip;
                </li>
            );
        }
        let pageDecremenEllipses = null;
        if (minPageLimit >= 1) {
            pageDecremenEllipses = (
                <li className="page-item" onClick={handleBackButtonClick}>
                    &hellip;
                </li>
            );
        }
        return (
            <div className="card-footer d-flex align-items-center">
                <p className="m-0 text-muted">{paginationText}</p>

                <ul className="pagination m-0 ms-auto">
                    <li className="page-item">
                        <button
                            className="page-link"
                            onClick={handleBackButtonClick}
                            disabled={previosDisabled}
                            aria-disabled={previosDisabled}
                            aria-label="previous page"
                        //pageRangeDisplayed={perPage}
                        >
                            «
                        </button>
                    </li>
                    {pageDecremenEllipses}
                    {pageNumbers}
                    {pageIncrementEllipses}
                    <li className="page-item">
                        <button
                            className="page-link"
                            onClick={handleNextButtonClick}
                            disabled={nextDisabled}
                            aria-disabled={nextDisabled}
                            aria-label="next page"
                        >
                            »
                        </button>
                    </li>
                </ul>
            </div>
        );
    };
    /* END DATATABLE */
    const CustomLoader = () => (
        <div style={{ padding: "24px" }}>
            <DivLoader color="primary" />
        </div>
    );


    const handleShow = (action, leaveId) => {
        setAction(action)
        if (action === 'Missing') {
            fetchMissingLeaveApprovers();
        }
        setShow(true);
    }



    const handleClose = () => {
        setShow(false);

        setTo('');
        setCc('');
        setSubject('');
        setLeaveStartDate('');
        setLeaveEndDate('');
        setApprover('');
        setApproverSource('');
    }

    return (
        <>
            <Loading
                loading={fullLoading}
                background="rgba(0, 0, 0, 0.5)"
                loaderColor="#fff"
            />

            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Manage</div>
                            <h2 className="page-title ">Leaves</h2>
                        </div>
                        <div className="col-12 col-md-auto ms-auto d-print-none">

                            <div className="btn-list">

                                <Link
                                    to="#"
                                    className="btn btn-primary mr-3"
                                    onClick={() => handleShow('Add', 0)}>

                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon icon-tabler icon-tabler-plus"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>

                                    &nbsp;Apply Leave
                                </Link>
                                <Link
                                    to="#"
                                    className="btn btn-outline-primary"
                                    onClick={() => handleShow('Missing', 0)}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="icon icon-tabler icon-tabler-plus"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        strokeWidth="2"
                                        stroke="currentColor"
                                        fill="none"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <line x1="12" y1="5" x2="12" y2="19"></line>
                                        <line x1="5" y1="12" x2="19" y2="12"></line>
                                    </svg>
                                    &nbsp;Add Missing Leave
                                </Link>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Leave Stats */}
            {leaveLisiting && leaveLisiting.length > 0 && (
                <div className="container-xl mt-3">
                    <div className="row g-2 db-stats-row">
                        <div className="col-6 col-md-2">
                            <div className="db-stat-card">
                                <div className="db-stat-icon" style={{ background: "#e8f0fe", color: "#1167e8" }}><FiCalendar size={18} /></div>
                                <div className="db-stat-value">{leaveLisiting[0]?.totalLeaveCount || 0}</div>
                                <div className="db-stat-label">Total Allocated</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-2">
                            <div className="db-stat-card">
                                <div className="db-stat-icon" style={{ background: "#ffedd5", color: "#c2410c" }}><FiBarChart2 size={18} /></div>
                                <div className="db-stat-value">{leaveLisiting[0]?.consumedLeaveCount || 0}</div>
                                <div className="db-stat-label">Used</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-2">
                            <div className="db-stat-card">
                                <div className="db-stat-icon" style={{ background: "#d1fae5", color: "#059669" }}><FiCheckCircle size={18} /></div>
                                <div className="db-stat-value">{leaveLisiting[0]?.balanceLeaveCount || 0}</div>
                                <div className="db-stat-label">Balance</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-2">
                            <div className="db-stat-card">
                                <div className="db-stat-icon" style={{ background: "#fef3c7", color: "#b45309" }}><FiClock size={18} /></div>
                                <div className="db-stat-value">{Array.isArray(leaveLisiting) ? leaveLisiting.filter(l => l.status == 0).length : 0}</div>
                                <div className="db-stat-label">Pending</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-2">
                            <div className="db-stat-card">
                                <div className="db-stat-icon" style={{ background: "#dcfce7", color: "#16a34a" }}><FiCheckCircle size={18} /></div>
                                <div className="db-stat-value">{Array.isArray(leaveLisiting) ? leaveLisiting.filter(l => l.status == 1).length : 0}</div>
                                <div className="db-stat-label">Approved</div>
                            </div>
                        </div>
                        <div className="col-6 col-md-2">
                            <div className="db-stat-card">
                                <div className="db-stat-icon" style={{ background: "#fee2e2", color: "#dc2626" }}><FiXCircle size={18} /></div>
                                <div className="db-stat-value">{Array.isArray(leaveLisiting) ? leaveLisiting.filter(l => l.status == 2).length : 0}</div>
                                <div className="db-stat-label">Rejected</div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-cards">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title">Listing</h3>
                                </div>
                                <div className="card-body border-bottom py-3">
                                    <div className="row">


                                        <div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Status
                                                </label>

                                                <select
                                                    className="form-select form-control"
                                                    name="srchStatus"
                                                    id="srchStatus"
                                                    placeholder="Select status"
                                                    value={srchStatus}
                                                    onChange={(e) => setSrchStatus(e.target.value)}
                                                >
                                                    <option value="">Select</option>
                                                    <option value="0">Pending</option>
                                                    <option value="1">Approved</option>
                                                    <option value="2">Rejected</option>
                                                    <option value="3">Cancelled</option>
                                                </select>


                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Leave Type
                                                </label>
                                                <select
                                                    className="form-select form-control"
                                                    name="srchLeaveType"
                                                    id="srchLeaveType"
                                                    placeholder="Select leaveType"
                                                    onChange={(e) => setSrchLeaveType(e.target.value)}
                                                    value={srchLeaveType}
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    <option value="0">Half Day</option>
                                                    <option value="1">Full day</option>

                                                </select>
                                            </div>
                                        </div>
                                        {/*<div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Leave Date
                                                </label>                  
                                                <DatePicker
                                                    name="srchLeaveDate"
                                                    value={srchLeaveDate}
                                                    selected={srchLeaveDate}
                                                    dateFormat="DD-MM-YYYY"
                                                    timeFormat=""
                                                    className=""
                                                    onChange={(e) => setSrchLeaveDate(e)}
                                                />
                                            </div>  
                                        </div>*/}

                                        <div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Month
                                                </label>
                                                <DatePicker
                                                    name="srchMonth"
                                                    value={srchMonth}
                                                    selected={srchMonth}
                                                    dateFormat="MM"
                                                    timeFormat=""
                                                    className=""
                                                    onChange={searchMonthChange}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Year
                                                </label>
                                                <DatePicker
                                                    name="srchYear"
                                                    value={srchYear}
                                                    selected={srchYear}
                                                    dateFormat="YYYY"
                                                    timeFormat=""
                                                    className=""
                                                    onChange={(e) => searchYearChange(e)}
                                                />
                                            </div>
                                        </div>
                                        {/* <div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Leave Start Date
                                                </label>                  
                                                <DatePicker
                                                    name="srchLeaveStartDate"
                                                    value={srchLeaveStartDate}
                                                    selected={srchLeaveStartDate}
                                                    dateFormat="DD-MM-YYYY"
                                                    timeFormat=""
                                                    className=""
                                                    onChange={(e) => setSrchLeaveStartDate(e)}
                                                />
                                            </div>  
                                        </div>
                                       <div className="col-md-2">
                                            <div className="mb-2">
                                                <label className="form-label required">
                                                    Leave End Date
                                                </label>                  
                                                <DatePicker
                                                    name="srchLeaveEndDate"
                                                    value={srchLeaveEndDate}
                                                    selected={srchLeaveEndDate}
                                                    dateFormat="DD-MM-YYYY"
                                                    timeFormat=""
                                                    className=""
                                                    onChange={(e) => setSrchLeaveEndDate(e)}
                                                />
                                            </div>  
                                        </div>*/}

                                        <div className="col-md-4">
                                            <div className="form-group mb-3 ">
                                                <label className="form-label">&nbsp;</label>
                                                <div>
                                                    <button
                                                        type="button"
                                                        name="btnSearch"
                                                        id="btnSearch"
                                                        className="btn btn-blue d-none d-sm-inline-block mr-3"
                                                        onClick={searchLeaves}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <circle cx="10" cy="10" r="7"></circle>
                                                            <line x1="21" y1="21" x2="15" y2="15"></line>
                                                        </svg>
                                                        Search
                                                    </button>
                                                    &nbsp;
                                                    <button
                                                        type="button"
                                                        name="btnReset"
                                                        id="btnReset"
                                                        className="btn btn-outline-primary mr-3"
                                                        onClick={clearSearch}
                                                    >
                                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                                            <line x1="18" y1="6" x2="6" y2="18"></line>
                                                            <line x1="6" y1="6" x2="18" y2="18"></line>
                                                        </svg>
                                                        Clear
                                                    </button>
                                                    <ExportCsv propsEmpName={filterUsers} propsHeaders={headerData} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive">

                                    <DataTable
                                        columns={columns}
                                        data={leaveLisiting}
                                        progressPending={loading}
                                        progressComponent={<CustomLoader />}
                                        pagination="true"
                                        paginationServer
                                        paginationTotalRows={totalRows}
                                        onChangeRowsPerPage={handlePerRowsChange}
                                        onChangePage={handlePageChange}
                                        paginationPerPage={perPage}
                                        paginationComponent={BootyPagination}
                                        sortServer
                                        onSort={handleSort}
                                    />

                                </div>
                                <div className="card-footer d-flex align-items-center">
                                    <p className="m-0 text-muted">
                                        Showing {/* <span>1</span> to <span>8</span> of{" "} */}
                                        <span>{totalRecords}</span> entries
                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal size="lg" show={show} onHide={handleClose}>

                <Loading
                    loading={fullLoading}
                    background="rgba(0, 0, 0, 0.5)"
                    loaderColor="#fff"
                />

                <Modal.Header closeButton>
                    <Modal.Title>
                        {action === "Missing" ? "Missing Leave" : action === "Edit" ? "Edit Leave" : "Add Leave"}
                    </Modal.Title>

                </Modal.Header>

                <Modal.Body>
                    <form
                        onSubmit={(e) => e.preventDefault()}
                        autoComplete={"off"}
                    >
                        <div className="row">
                            {action === "Missing" && (
                                <>
                                <div className="col-md-12 mb-1">
                                    <label className="form-label fw-bold">Approver</label>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label required">Department Head</label>
                                        <Select
                                            placeholder="Select Department Head"
                                            options={deptHeadApprovers.map(a => ({ value: a.id, label: `${a.name} (${a.email})` }))}
                                            value={approverSource === "head" && approver ? deptHeadApprovers.filter(a => a.id == approver).map(a => ({ value: a.id, label: `${a.name} (${a.email})` }))[0] : null}
                                            onChange={(opt) => { setApprover(opt ? opt.value : ""); setApproverSource("head"); }}
                                            isClearable
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label required">Department Employee</label>
                                        <Select
                                            placeholder="Select Employee"
                                            options={deptEmployeeApprovers.map(a => ({ value: a.id, label: `${a.name} (${a.email})` }))}
                                            value={approverSource === "emp" && approver ? deptEmployeeApprovers.filter(a => a.id == approver).map(a => ({ value: a.id, label: `${a.name} (${a.email})` }))[0] : null}
                                            onChange={(opt) => { setApprover(opt ? opt.value : ""); setApproverSource("emp"); }}
                                            isClearable
                                        />
                                    </div>
                                </div>
                                </>
                            )}
                            {/* Row 1: Leave Type + Leave Category */}
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Leave Type</label>
                                    <select
                                        className={`form-select form-control ${validate.validate && validate.validate.leaveType ? "is-invalid" : ""}`}
                                        onChange={(e) => { setLeaveType(e.target.value); setHalfDaySession(''); }}
                                        value={leaveType}
                                    >
                                        <option value="">Select Leave Type</option>
                                        <option value="1">Full Day</option>
                                        <option value="0">Half Day</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Leave Category</label>
                                    <select
                                        className={`form-select form-control ${validate.validate && validate.validate.leaveTypeId ? "is-invalid" : ""}`}
                                        onChange={(e) => setLeaveTypeId(e.target.value)}
                                        value={leaveTypeId}
                                    >
                                        <option value="">Select Category</option>
                                        {leaveTypeData.map((l) => (
                                            <option key={l.id} value={l.id}>{l.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {/* Row 2: Dates — Start Date always, End Date for Full Day, Session for Half Day */}
                            <div className="col-md-6">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Start Date</label>
                                    <DatePicker
                                        name="leaveStartDate"
                                        value={leaveStartDate}
                                        selected={leaveStartDate}
                                        dateFormat="DD-MM-YYYY"
                                        timeFormat=""
                                        className={`${validate.validate && validate.validate.leaveStartDate ? "is-invalid" : ""}`}
                                        onChange={(e) => setLeaveStartDate(e)}
                                        isValidDate={action === "Missing" ? (current) => current.isBefore(moment().startOf('day')) : (current) => current.isSameOrAfter(moment().startOf('day'))}
                                    />
                                </div>
                            </div>
                            {leaveType === "1" && (
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label className="form-label required">End Date</label>
                                        <DatePicker
                                            name="leaveEndDate"
                                            value={leaveEndDate}
                                            selected={leaveEndDate}
                                            dateFormat="DD-MM-YYYY"
                                            timeFormat=""
                                            className={`${validate.validate && validate.validate.leaveEndDate ? "is-invalid" : ""}`}
                                            onChange={(e) => setLeaveEndDate(e)}
                                            isValidDate={action === "Missing" ? (current) => current.isBefore(moment().startOf('day')) && current.isSameOrAfter(moment(leaveStartDate || undefined).startOf('day')) : (current) => current.isSameOrAfter(moment(leaveStartDate || undefined).startOf('day'))}
                                        />
                                    </div>
                                </div>
                            )}
                            {leaveType === "0" && (
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label className="form-label required">Session</label>
                                        <select
                                            className={`form-select form-control ${validate.validate && validate.validate.halfDaySession ? "is-invalid" : ""}`}
                                            value={halfDaySession}
                                            onChange={(e) => setHalfDaySession(e.target.value)}
                                        >
                                            <option value="">Select Session</option>
                                            <option value="first">First Half (Morning)</option>
                                            <option value="second">Second Half (Afternoon)</option>
                                        </select>
                                    </div>
                                </div>
                            )}

                            {/* Row 3: Subject */}
                            <div className="col-md-12">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Subject</label>
                                    <input
                                        type="text"
                                        className={`form-control ${validate.validate && validate.validate.subject ? "is-invalid" : ""}`}
                                        placeholder="Brief reason for leave"
                                        onChange={(e) => setSubject(e.target.value)}
                                        value={subject}
                                    />
                                </div>
                            </div>

                            {/* Row 4: Approver + Notify — only for normal leave, not missing */}
                            {action !== "Missing" && (
                                <>
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label className="form-label required">Approver</label>
                                            <MultiSelect
                                                key={action === "Edit" ? "to-edit-" + editLeaveId : "to-add"}
                                                onChange={handleOnchangeTo}
                                                options={newHeads}
                                                defaultValue={action === "Edit" ? to : ""}
                                                className={`${validate.validate && validate.validate.to ? "is-invalid" : ""}`}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group mb-3">
                                            <label className="form-label">Notify (CC)</label>
                                            <MultiSelect
                                                key={action === "Edit" ? "cc-edit-" + editLeaveId : "cc-add"}
                                                onChange={handleOnchangeCC}
                                                options={newHeadsCC}
                                                defaultValue={action === "Edit" ? cc : ""}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Row 5: Reason — simplified editor */}
                            <div className="col-md-12">
                                <div className="form-group mb-3">
                                    <label className="form-label required">Reason</label>
                                    <JoditEditor
                                        ref={editor}
                                        config={config}
                                        value={reason}
                                        tabIndex={1}
                                        onBlur={newContent => setReason(newContent)}
                                        onChange={newContent => setReason(newContent)}
                                    />
                                    <div className={`invalid-feedback text-start ${validate.validate && validate.validate.reason ? "d-block" : "d-none"}`}>
                                        {validate.validate && validate.validate.reason ? validate.validate.reason : ""}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="form-footer">

                                    <button
                                        type="button"
                                        className="mr-3 btn btn-primary"
                                        onClick={action === "Missing" ? handleMissingSubmit : action === "Edit" ? handleEditSubmit : handleSubmit}
                                        disabled={disabled}
                                    >{disabled ? "Submitting..." : "Submit"}</button>


                                    &nbsp;&nbsp;

                                </div>
                            </div>
                        </div>


                    </form>
                </Modal.Body>
            </Modal>


            {
                (showLeaveModel.show == 'show' && <ViewLeaveDetails closeLeave={closeLeave} editLeaveId={editLeaveId} viewData={viewData} />)
            }
        </>
    )
}

export default List